// ค่าคงที่/ตัวช่วยของเพดานต่อบัญชีฝาก — ใช้ร่วมหน้า Banks (ตั้งค่า) และหน้าความจุบัญชี (รายงาน + what-if)
// ⚠️ ช่วงค่าต้องตรงกับ backend: adminBankController validate limit_window_seconds 1..3600, window_transaction_limit 0..10000 (= p_cap ของ RPC)

export const WINDOW_MAX_SECONDS = 3600; // สูงสุด 60 นาที (ตรงกับ DB CHECK chk_banks_limit_window_seconds)
export const WINDOW_DEFAULT_SECONDS = 300;
export const WINDOW_MAX_LIMIT = 10000;

/** แสดงช่วงเวลาให้อ่านง่าย: 90 → "90 วิ", 300 → "5 นาที", 7200 → "2 ชม." */
export const fmtWindow = (sec: number): string => {
  const s = Number(sec) || WINDOW_DEFAULT_SECONDS;
  if (s % 3600 === 0) return `${s / 3600} ชม.`;
  if (s % 60 === 0) return `${s / 60} นาที`;
  return `${s.toLocaleString()} วิ`;
};

export interface BankStyle {
  bg: string;
  text: string;
  name: string;
}

const BANK_STYLES: Record<string, BankStyle> = {
  SCB: { bg: 'bg-purple-600', text: 'text-white', name: 'ไทยพาณิชย์' },
  KBANK: { bg: 'bg-green-600', text: 'text-white', name: 'กสิกรไทย' },
  BBL: { bg: 'bg-blue-700', text: 'text-white', name: 'กรุงเทพ' },
  KTB: { bg: 'bg-sky-500', text: 'text-white', name: 'กรุงไทย' },
  BAY: { bg: 'bg-yellow-500', text: 'text-gray-800', name: 'กรุงศรี' },
  GSB: { bg: 'bg-pink-500', text: 'text-white', name: 'ออมสิน' },
};

/** สี/ชื่อธนาคารจาก bank_code สำหรับ chip ในตาราง (ไม่รู้จัก → เทา + code) */
export const getBankStyle = (code: string): BankStyle =>
  BANK_STYLES[code] || { bg: 'bg-gray-500', text: 'text-white', name: code };
